import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

import { ImportBatchDisableDeleteService } from "src/app/_services/import-services/import-batch-disable-delete.service";
import { AuthorizeImportBatchDisableDeleteSSE, AuthorizeImportBatchDisableDeleteSSEError, AuthorizeImportBatchDisableDeleteSSESuccess, CancelBatchDisableDeleteImport, CancelBatchDisableDeleteImportError, CancelBatchDisableDeleteImportSuccess, ClearBatchDisableDeleteImportSession, DownloadBatchDisableDeleteImportErrorList, DownloadBatchDisableDeleteImportErrorListError, DownloadBatchDisableDeleteImportErrorListSuccess, HasImportedBatchDisableDelete, HasImportedBatchDisableDeleteError, HasImportedBatchDisableDeleteSuccess, ResetBatchDisableDeleteImportState, UploadBatchDisableDeleteCSV, UploadBatchDisableDeleteCSVError, UploadBatchDisableDeleteCSVSuccess } from "./import-batch-disable-delete.action";

@Injectable()
export class ImportBatchDisableDeleteEffects {
  constructor(
    private actions$: Actions,
    private importBatchDisableDeleteService: ImportBatchDisableDeleteService
  ) {}

  public uploadBatchDisableDeleteCSVEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadBatchDisableDeleteCSV),
      switchMap((payload) =>
        this.importBatchDisableDeleteService.uploadCSVFile$(payload.payload).pipe(
          map((result: boolean) => {
            return UploadBatchDisableDeleteCSVSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UploadBatchDisableDeleteCSVError({ error: error }));
          })
        )
      )
    )
  );

  public authorizeImportBatchDisableDeleteSSEEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthorizeImportBatchDisableDeleteSSE),
      switchMap(() =>
        this.importBatchDisableDeleteService.authorizeSSERequest$().pipe(
          map((result: boolean) => {
            return AuthorizeImportBatchDisableDeleteSSESuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(AuthorizeImportBatchDisableDeleteSSEError({ error: error }));
          })
        )
      )
    )
  );

  public hasImportedBatchDisableDeleteEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HasImportedBatchDisableDelete),
      switchMap(() =>
        this.importBatchDisableDeleteService.hasImport$().pipe(
          map((result: number) => {
            return HasImportedBatchDisableDeleteSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(HasImportedBatchDisableDeleteError({ error: error }));
          })
        )
      )
    )
  );

  public downloadBatchDisableDeleteImportErrorListEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DownloadBatchDisableDeleteImportErrorList),
      switchMap(() =>
        this.importBatchDisableDeleteService.downloadErrorList$().pipe(
          map((result: string[]) => {
            return DownloadBatchDisableDeleteImportErrorListSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(DownloadBatchDisableDeleteImportErrorListError({ error: error }));
          })
        )
      )
    )
  );

  public clearBatchDisableDeleteImportSessionEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClearBatchDisableDeleteImportSession),
      switchMap(() =>
        this.importBatchDisableDeleteService.clearImportSession$().pipe(
          map(() => {
            return ResetBatchDisableDeleteImportState();
          })
        )
      )
    )
  );

  public cancelBatchDisableDeleteImportEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CancelBatchDisableDeleteImport),
      switchMap(() =>
        this.importBatchDisableDeleteService.cancelImport$().pipe(
          map(() => {
            return CancelBatchDisableDeleteImportSuccess();
          }),
          catchError(() => {
            return of(CancelBatchDisableDeleteImportError());
          })
        )
      )
    )
  );
}